// Coordinate-based world rules: the same place always grows the same landscape.
import { B } from './blocks.js';
import { hash2 } from './util.js';
export const REGION = 32;
export const BIOMES = [
  { id: 'meadow', name: 'Blossom Meadow', icon: '🌸', colour: '#83c961', surface: B.GRASS, tree: 'birch', plant: B.FLOWER_RED },
  { id: 'desert', name: 'Sunstone Sands', icon: '🌵', colour: '#e8c67c', surface: B.SAND, tree: 'palm', plant: B.DEAD_BUSH },
  { id: 'snow', name: 'Snowy Pines', icon: '❄️', colour: '#c6e3ee', surface: B.SNOW_GRASS, tree: 'pine', plant: B.SNOW_BUSH },
  { id: 'crystal', name: 'Crystal Gardens', icon: '💎', colour: '#b795e6', surface: B.GRASS, tree: 'crystal', plant: B.CRYSTAL_SHARD },
];
export const regionKey = (rx, rz) => `${rx},${rz}`;
export const homeRegion = (rx, rz) => rx >= -1 && rx <= 0 && rz >= -1 && rz <= 0;
export const localCoord = (n) => ((Math.floor(n) % REGION) + REGION) % REGION;
export function biomeAt(x, z) {
  const rx = Math.floor(x / REGION),
    rz = Math.floor(z / REGION);
  if (homeRegion(rx, rz)) return BIOMES[0];
  const a = Math.floor((rx + 1) / 2),
    b = Math.floor((rz + 1) / 2);
  return BIOMES[(((a + b * 2) % 4) + 4) % 4];
}
export function onTrail(x, z) {
  // The town's four exits join a continuous, flat network of trails.
  return Math.abs(x) <= 1 || Math.abs(z) <= 1 || Math.abs(localCoord(x) - 16) <= 1 || Math.abs(localCoord(z) - 16) <= 1;
}
export function groundHeight(x, z) {
  if (homeRegion(Math.floor(x / REGION), Math.floor(z / REGION))) return 40;
  const lx = localCoord(x),
    lz = localCoord(z);
  const roadDistance = Math.min(Math.abs(x), Math.abs(z), Math.abs(lx - 16), Math.abs(lz - 16));
  const edge = Math.min(lx, lz, 31 - lx, 31 - lz);
  const hill = Math.floor((Math.sin(x * 0.055) + Math.cos(z * 0.06) + 2) * 1.4);
  return 40 + Math.max(0, Math.min(hill, edge, roadDistance - 3));
}
// About one wilderness region in five from the second ring out has a Mossy Giant instead of its slime or zombie.
export const giantRegion = (rx, rz) =>
  !homeRegion(rx, rz) && Math.max(Math.abs(rx), Math.abs(rz)) >= 2 && hash2(rx, rz, 77) < 0.18;
// Where it stands in its region (feet centre, local). Its 2×2 body covers cells x 7–9, z 18–19: the level strip
// beside the east–west trail, always at ground height 40, clear of trees, ore seams, the mine trench and the trail.
export const GIANT_SPOT = { x: 8.5, z: 19 };
export function wildStation(rx, rz) {
  if (homeRegion(rx, rz)) return null;
  const topic = Math.floor(hash2(rx, rz, 27) * 6) % 6;
  return { id: `wild:${rx},${rz}`, rx, rz, x: rx * REGION + 16, z: rz * REGION + 16, topic };
}
